import React, { useContext, useEffect, useState } from 'react';
import { Form, Row, Col, Button } from 'react-bootstrap';
import { LanguageContext } from '../Language/LanguageContext';
import { HeaderTitle, NotifyContext, Loading } from '../Library'
import { deliveryType } from './DeliveryStatusConstant';
import DatePicker from "react-datepicker";
import { listCompany } from '../Network/Company';
import { createDelivery } from '../Network/Delivery'
import { useHistory } from 'react-router-dom';

function CreateDelivery() {
    const history = useHistory()
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.delivery
    const notify = useContext(NotifyContext)

    const [isLoading, setIsLoading] = useState(false)
    const [trackingNo, setTrackingNo] = useState("")
    const [sender, setSender] = useState("")
    const [senderAddress, setSenderAddress] = useState("")
    const [senderDate, setSenderDate] = useState(new Date())
    const [provider, setProvider] = useState("")
    const [receiveDate, setReceiveDate] = useState(new Date())
    const [type, setType] = useState(deliveryType.PARCEL)

    const [companyList, setCompanyList] = useState([])
    const [companyId, setCompanyId] = useState("")

    const [isError, setIsError] = useState(false)

    const typeOptions = [
        { value: deliveryType.PARCEL, label: lang.parcel },
        { value: deliveryType.MAIL, label: lang.mail }
    ]

    const onSubmit = () => {
        if(!trackingNo || !sender || !senderAddress || !provider || !companyId){
            notify.showNotify(lang.not_complete, lang.not_complete_desc, 1)
            setIsError(true)
            return
        }

        setIsLoading(true)
        createDelivery(trackingNo, sender, senderAddress, provider, senderDate, receiveDate, type, companyId,
            (data)=> {
                notify.showNotify(lang.add_delivery, lang.add_delivery_desc, 0)
                setIsLoading(false)
                history.push("/delivery")
            },
            (error) =>{ 
                notify.showNotify("Somethings Wrong", error.message, 2)
                setIsLoading(false)
            })
    }

    useEffect(()=>{
        const fetchCompanyData = () => {
            listCompany(
                (data)=>{
                    setCompanyList(data)
                },
                (error) => {  }
            )
        }
        fetchCompanyData()
    },[])

    return (
        <div>
            { isLoading ? <Loading/>: null }
            <HeaderTitle 
            title={lang.add_parcel}
            isShowBack={true}
            backTo="/delivery"/>
            <Row>
                <Col className="content-container" md={10} lg={8} xl={6}>
                    <Form onSubmit={(e)=>{
                        e.preventDefault()
                        onSubmit()
                    }}>
                        <Form.Group>
                            <Form.Label>{lang.tracking_no}</Form.Label>
                            <Form.Control
                            value={trackingNo}
                            isInvalid={isError && !trackingNo}
                            onChange={(e)=>setTrackingNo(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.sender}</Form.Label>
                            <Form.Control
                            value={sender}
                            isInvalid={isError && !sender}
                            onChange={(e)=>setSender(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.sender_address}</Form.Label>
                            <Form.Control
                            value={senderAddress}
                            isInvalid={isError && !senderAddress}
                            onChange={(e)=>setSenderAddress(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.provider}</Form.Label>
                            <Form.Control
                            value={provider}
                            isInvalid={isError && !provider}
                            onChange={(e)=>setProvider(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.sender_date}</Form.Label>
                            <DatePicker
                            className='form-control'
                            selected={senderDate}
                            onChange={(date)=>setSenderDate(date)}
                            dateFormat="d MMMM yyyy"
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.estimate_receive_date}</Form.Label>
                            <DatePicker
                            minDate={senderDate}
                            className='form-control'
                            selected={receiveDate}
                            onChange={(date)=>setReceiveDate(date)}
                            dateFormat="d MMMM yyyy"
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.type}</Form.Label>
                            <Form.Control 
                            as="select"
                            onChange={(e)=>setType(e.target.value)}
                            >
                                { typeOptions.map((item, key) =>
                                <option key={key} value={item.value}>{item.label}</option>
                                )}
                            </Form.Control>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.company_receive}</Form.Label>
                            <Form.Control 
                            as="select"
                            value={companyId}
                            isInvalid={isError && !companyId}
                            onChange={(e)=>setCompanyId(e.target.value)}>
                                <option value={""}>{lang.select_company}</option>
                                { companyList.map((item, key) => 
                                <option key={key} value={item.id}>
                                    {item.name}
                                </option>
                                )}
                            </Form.Control>
                        </Form.Group>
                        
                        <hr/>
                        <Button type="submit">
                            {lang.add_parcel}
                        </Button>
                    </Form>
                </Col>
            </Row>
        </div>
    )
}

export default CreateDelivery;
